import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PedidoStatusMultiselectComponent } from './multiselect';
import { PedidoStatusPipe } from './pipes';
import { PedidoStatusAmostraMultiselectComponent, PedidoStatusAmostraPipe, PedidoStatusAmostraBadgePipe } from './amostra';
import { PedidoStatusBadgeComponent, PedidoStatusBadgeNaoConfirmadoComponent, PedidoStatusBadgeNaoLiberadoComponent, PedidoStatusBadgeConfirmadoComponent, PedidoStatusBadgeEmAnaliseComponent, PedidoStatusBadgeAprovadoComponent, PedidoStatusBadgeReprovadoComponent, PedidoStatusBadgeProducaoComponent, PedidoStatusBadgeFaturadoComponent, PedidoStatusBadgeFaturadoParcialComponent, PedidoStatusBadgeCanceladoComponent, PedidoStatusBadgeOutroComponent, PedidoStatusBadgeConfirmandoERPComponent, PedidoStatusBadgeAbertoERPComponent, PedidoStatusBadgeRevisaoComponent } from './badge';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PedidoStatusMultiselectComponent,
        PedidoStatusAmostraMultiselectComponent,

        // Badges
        PedidoStatusBadgeComponent,
        PedidoStatusBadgeNaoConfirmadoComponent,
        PedidoStatusBadgeNaoLiberadoComponent,
        PedidoStatusBadgeConfirmadoComponent,
        PedidoStatusBadgeEmAnaliseComponent,
        PedidoStatusBadgeAprovadoComponent,
        PedidoStatusBadgeReprovadoComponent,
        PedidoStatusBadgeProducaoComponent,
        PedidoStatusBadgeFaturadoComponent,
        PedidoStatusBadgeFaturadoParcialComponent,
        PedidoStatusBadgeCanceladoComponent,
        PedidoStatusBadgeOutroComponent,
        PedidoStatusBadgeConfirmandoERPComponent,
        PedidoStatusBadgeAbertoERPComponent,
        PedidoStatusBadgeRevisaoComponent,

        // Pipes
        PedidoStatusPipe,
        PedidoStatusAmostraPipe,
        PedidoStatusAmostraBadgePipe
    ],
    exports: [
        PedidoStatusMultiselectComponent,
        PedidoStatusAmostraMultiselectComponent,

        // Badges
        PedidoStatusBadgeComponent,
        PedidoStatusBadgeNaoConfirmadoComponent,
        PedidoStatusBadgeNaoLiberadoComponent,
        PedidoStatusBadgeConfirmadoComponent,
        PedidoStatusBadgeEmAnaliseComponent,
        PedidoStatusBadgeAprovadoComponent,
        PedidoStatusBadgeReprovadoComponent,
        PedidoStatusBadgeProducaoComponent,
        PedidoStatusBadgeFaturadoComponent,
        PedidoStatusBadgeFaturadoParcialComponent,
        PedidoStatusBadgeCanceladoComponent,
        PedidoStatusBadgeOutroComponent,
        PedidoStatusBadgeConfirmandoERPComponent,
        PedidoStatusBadgeAbertoERPComponent,
        PedidoStatusBadgeRevisaoComponent,

        // Pipes
        PedidoStatusPipe,
        PedidoStatusAmostraPipe,
        PedidoStatusAmostraBadgePipe
    ],
    providers: [
        // Pipes
        PedidoStatusPipe,
        PedidoStatusAmostraPipe,
        PedidoStatusAmostraBadgePipe
    ]
})
export class PedidoStatusModule { }
